import Vue from 'vue'
import App from './App/App.vue'

import router from './App/router'
import store from './App/store'


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

require('./App/common/filters')

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
